import React from "react"
import Image from "next/image"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Button from "../reusable/components/Button"
import {filterUrl} from "../filter/FilterUrl"

const ComparisonDefaultComponent = () => {
	const {t} = useTranslation()

	return (
		<div className="ps-lg-0 pt-lg-5 pb-lg-5 mb-lg-5  d-lg-flex align-items-center justify-content-between">

			<div style={{minHeight: 208}}
				className="d-md-none row p-0 ps-2 rounded-3 overflow-hidden position-relative mb-4">
				<Image src={"/assets/images/cyclists-comparison-mobile-min.jpg"}
					objectFit="cover"
					layout="fill"/>
				<Typography className="text-white position-absolute text-center top-50"
					variant="heading1">{t("compare-e-bikes")}</Typography>
			</div>

			<div className="mb-4">
				<Typography className="d-none d-md-block mb-3 text-uppercase"
					variant="heading1">{t("compare-e-bikes")}</Typography>
				<Typography className="mb-4"
					variant="bodyLg">{t("select-couple-e-bikes-to-compare")}</Typography>
				<Button className="col-12 col-md-auto"
					color="orange"
					fontSizeSmall
					label={t("select-couple-e-bikes-cta")}
					href={filterUrl({}, null, null)}/>
			</div>

			<div className="d-none d-md-block col-6 p-0 position-relative overflow-hidden">
				<Image src="/assets/images/cyclists-comparison-desktop-min.jpg"
					alt="bike"
					layout="responsive"
					width={638}
					height={330}
					objectFit="contain"
					objectPosition="center"
				/>
			</div>
		</div>
	)
}

export default ComparisonDefaultComponent
